import { render, staticRenderFns } from "./TdxDropdown.vue?vue&type=template&id=278e05f6&scoped=true&"
import script from "./TdxDropdown.vue?vue&type=script&lang=js&"
export * from "./TdxDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TdxDropdown.vue?vue&type=style&index=0&id=278e05f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e05f6",
  null
  
)

export default component.exports